export enum TENANT_PARTNER_TYPES {
  academic = 'academic',
  enterprise = 'enterprise',
  organization = 'organization',
  uncategorized = 'uncategorized',
}
